<div class="summary-container">
  <div class="card">
    <div class="card-body">
      <h3 class="text-center mb-4">Resumen de Verificación</h3>

      <div class="verification-steps" *ngIf="status()">
        <div class="step" [class.completed]="status()?.payment_card_id !== null">
          <i class="bi"
             [class.bi-check-circle-fill]="status()?.payment_card_id !== null"
             [class.bi-circle]="status()?.payment_card_id === null"></i>
          <span>Tarjeta agregada</span>
        </div>

        <div class="step"
             [class.completed]="status()?.biometric_completed"
             *ngIf="status()?.biometric_required">
          <i class="bi"
             [class.bi-check-circle-fill]="status()?.biometric_completed"
             [class.bi-circle]="!status()?.biometric_completed"></i>
          <span>Verificación biométrica</span>
        </div>
      </div>

      <div class="alert alert-info mt-4" *ngIf="status()?.can_complete">
        <p class="mb-0">Has completado todos los pasos requeridos.</p>
      </div>

      <div class="alert alert-warning mt-4" *ngIf="!status()?.can_complete">
        <p class="mb-0">Aún hay pasos pendientes por completar.</p>
      </div>

      <app-button
        class="mt-4"
        [disabled]="!status()?.can_complete || completing()"
        (clicked)="complete()">
        {{ completing() ? 'Procesando...' : 'Completar Verificación' }}
      </app-button>
    </div>
  </div>
</div>
